import { render as renderIrt } from '../../../../js/new/irt-symbol';
import {
  formatAuto,
  formatIrtAuto,
  formatIrtMedium,
  formatNumber,
  formatPercent,
  formatUsd,
} from './format.js';

function setText(root, selector, value) {
  root.querySelectorAll(selector).forEach((node) => { renderIrt(node, value); });
}

function setChange(root, selector, value) {
  const numeric = Number(value);
  const available = value !== null && value !== '' && Number.isFinite(numeric);
  root.querySelectorAll(selector).forEach((node) => {
    node.textContent = available ? formatPercent(numeric) : '—';
    node.classList.toggle('toup', available && numeric > 0);
    node.classList.toggle('todown', available && numeric < 0);
  });
}

function setRowHidden(root, selector, hidden) {
  root.querySelectorAll(selector).forEach((node) => {
    node.removeAttribute('hidden');
    node.style.display = hidden ? 'none' : '';
  });
}

function renderAsset(root, side, asset) {
  const trigger = root.querySelector(`[data-ac-side-type-calc="${side}"]`);
  if (trigger) {
    trigger.setAttribute('slug', asset.slug);
    trigger.setAttribute(`${side}-asset-type`, asset.type);
    trigger.setAttribute('aria-label', `انتخاب ${side === 'base' ? 'ارز مبدا' : 'ارز مقصد'}؛ ${asset.fa_name || asset.name}`);
  }
  const logo = root.querySelector(`[data-av-value="logo-${side}"]`);
  if (logo) {
    logo.src = `https://cdn.arz.digital/cr-odin/img/assets/${encodeURIComponent(asset.slug)}/64x64.png`;
    logo.alt = asset.name || asset.fa_name || asset.symbol;
  }
  setText(root, `[data-av-value="symbol-${side}"]`, asset.type === 'commodity' && asset.fa_symbol ? asset.fa_symbol : asset.symbol);
  setText(root, `[data-av-value="faname-${side}"]`, asset.fa_name || asset.name);
  setText(root, `[data-av-value="faname-symbol-${side}"]`, `${asset.fa_name || asset.name} (${asset.symbol})`);
}

export function renderAmounts(state, { preserveEditedInput = false } = {}) {
  const { root, base } = state;
  const baseInput = root.querySelector('[data-av-model-name="base"]');
  const quoteInput = root.querySelector('[data-av-model-name="quote"]');
  if (baseInput && !(preserveEditedInput && state.lastEdited === 'base')) baseInput.value = formatNumber(state.baseAmount);
  if (quoteInput && !(preserveEditedInput && state.lastEdited === 'quote')) quoteInput.value = formatNumber(state.quoteAmount);

  setText(root, '.baseval-autonumber', formatAuto(state.baseAmount));
  setText(root, '.quoteval-autonumber', formatAuto(state.quoteAmount));
  setText(root, '[data-av-value="total-value-irt"]', formatIrtMedium(state.baseAmount * Number(base.toman)));
}

export function render(state) {
  const { root, base, quote } = state;
  renderAmounts(state);
  renderAsset(root, 'base', base);
  renderAsset(root, 'quote', quote);
  ['base', 'quote'].forEach((side) => {
    const asset = state[side];
    root.querySelectorAll(`[data-converter-currency-label="${side}"]`).forEach((label) => {
      const linked = state.mode === 'convert' && asset.type === 'fiat' && asset.slug !== 'ir-toman'
        && Boolean(label.closest('.basetotoman, .quotetotoman'));
      let link = label.querySelector('a');
      if (!linked) {
        if (link) link.replaceWith(...link.childNodes);
        return;
      }
      if (!link) {
        link = document.createElement('a');
        link.style.color = 'inherit';
        link.append(...label.childNodes);
        label.append(link);
      }
      link.setAttribute('href', `/currencies/${encodeURIComponent(asset.slug)}/`);
      link.title = `قیمت ${asset.fa_name || asset.name}`;
    });
  });
  setText(root, '[data-av-value="1baseAsQuote"]', formatAuto(state.rate));
  setText(root, '[data-av-value="1basePriceDollar"]', formatUsd(base.usd));
  setText(root, '[data-av-value="1quotePriceDollar"]', formatUsd(quote.usd));
  setText(root, '[data-av-value="1basePriceIrt"]', formatIrtAuto(base.toman));
  setText(root, '[data-av-value="1quotePriceIrt"]', formatIrtAuto(quote.toman));
  setText(root, '[data-av-value="base-mc"]', formatUsd(base.market_cap));
  setText(root, '[data-av-value="quote-mc"]', formatUsd(quote.market_cap));
  setText(root, '[data-av-value="base-rank"]', formatNumber(base.rank));
  setText(root, '[data-av-value="quote-rank"]', formatNumber(quote.rank));
  setText(root, '[data-av-value="base-dominance"]', formatPercent(base.dominance));
  setText(root, '[data-av-value="quote-dominance"]', formatPercent(quote.dominance));
  setChange(root, '[data-av-value="1baseChangeDollar"]', base.price_change_percent_24h);
  setChange(root, '[data-av-value="1quoteChangeDollar"]', quote.price_change_percent_24h);
  setChange(root, '[data-av-value="1baseChangeIrt"]', base.price_change_percent_irt_24h);
  setChange(root, '[data-av-value="1quoteChangeIrt"]', quote.price_change_percent_irt_24h);

  setRowHidden(root, '.basetodollar', base.slug === 'united-states-dollar');
  setRowHidden(root, '.basetotoman', base.slug === 'ir-toman');
  setRowHidden(root, '.quotetodollar', quote.slug === 'united-states-dollar');
  setRowHidden(root, '.quotetotoman', quote.slug === 'ir-toman');

  const adLink = root.querySelector('.adbuycont a');
  const adContainer = root.querySelector('.adbuycont');
  if (adLink && adContainer) {
    const advertisedAsset = base.type === 'coin'
      ? base
      : { slug: 'tether', fa_name: 'تتر', name: 'Tether' };
    const name = advertisedAsset.fa_name || advertisedAsset.name;
    const href = advertisedAsset.slug === 'tether' && base.type !== 'coin'
      ? 'https://buy.arzdigital.com/?slug=tether'
      : `https://buy.arzdigital.com?slug=${encodeURIComponent(advertisedAsset.slug)}`;
    const buttonText = base.type === 'coin'
      ? `خرید سریع ${name} + جایزه شیبا`
      : 'تبدیل آنی با تخفیف کارمزد';

    adContainer.hidden = false;
    adContainer.style.display = '';
    adLink.href = href;
    adLink.setAttribute('slug', advertisedAsset.slug);
    adLink.title = buttonText;
    setText(adLink, '.adscoiname', buttonText);
  }
}

export function emitInteraction(root, name, startedAt) {
  const duration = Math.max(0, performance.now() - startedAt);
  root.dispatchEvent(new CustomEvent('arz:converter-interaction', {
    bubbles: true,
    detail: { name, duration },
  }));
}
